import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
  Stack,
  ButtonBase,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link as RouterLink } from "react-router-dom";

function Footer() {
  const sections = [
    {
      title: "Soluciones",
      links: [
        { label: "Software hotelero", to: "/" },
        { label: "Gestor de canales para Airbnb", to: "/" },
      ],
    },
    {
      title: "Comercio hotelero",
      links: [
        { label: "Gestor de canales para hoteles", to: "/" },
        { label: "Motor de reservas", to: "/" },
        { label: "Sitios web para hoteles", to: "/" },
        { label: "Tarifas inteligentes", to: "/" },
        { label: "Metabuscadores", to: "/" },
        { label: "Pagos", to: "/" },
        { label: "GDS", to: "/" },
        { label: "Tienda de apps", to: "/" },
      ],
    },
    {
      title: "Recursos",
      links: [
        { label: "Distribución", to: "/" },
        { label: "Tecnología", to: "/" },
        { label: "Marketing", to: "/" },
        { label: "Grupos hoteleros", to: "/" },
        { label: "Casos de éxito", to: "/" },
        { label: "AWS", to: "/" },
        { label: "Videos evento Sync", to: "/" },
      ],
    },
    {
      title: "Integraciones",
      links: [
        { label: "Asociados integrados", to: "/" },
        { label: "Encuentra un experto", to: "/" },
        { label: "Buscador de PMS", to: "/" },
        { label: "Programas de asociados", to: "/" },
      ],
    },
    {
      title: "Empresa",
      links: [
        { label: "Contáctanos", to: "/" },
        { label: "Soporte", to: "/" },
        { label: "Facturación y pagos", to: "/" },
        { label: "Empleo", to: "/" },
        { label: "Noticias", to: "/" },
        { label: "Eventos", to: "/" },
        { label: "Avisos legales", to: "/" },
      ],
    },
  ];

  const Social = ({ href, label, Icon }) => (
    <IconButton
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      sx={{
        color: "#ECECEC",
        "&:hover": { color: "#FFE735" },
        "&:focus-visible": { outline: "2px solid #FFE735", outlineOffset: 2 },
      }}
    >
      <Icon />
    </IconButton>
  );

  return (
    <Box
      component="footer"
      role="contentinfo"
      sx={{
        background: "linear-gradient(135deg, #903AF2 0%, #6A1FBF 100%)",
        color: "#ECECEC",
        pt: { xs: 6, md: 8 },
        pb: { xs: 4, md: 6 },
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        {/* CTA superior */}
        <Box
          sx={{
            mb: { xs: 5, md: 7 },
            p: { xs: 2.5, md: 3 },
            borderRadius: 3,
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0.10))",
            boxShadow: "0 0 24px rgba(255,255,255,0.35)",
          }}
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} md={8}>
              <Typography
                sx={{
                  fontWeight: 900,
                  fontFamily: "'Red Hat Display', sans-serif",
                  fontSize: { xs: "1.25rem", md: "1.5rem" },
                  textShadow: "0 1px 2px rgba(0,0,0,0.25)",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                ¿Listo para más reservas y menos trabajo?
              </Typography>
              <Typography
                sx={{
                  mt: 0.5,
                  color: "rgba(255,255,255,0.92)",
                  fontFamily: "'Merriweather Sans', sans-serif",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Probá Ubika sin tarjeta. Te ayudamos con la configuración
                inicial.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack
                direction="row"
                spacing={1.5}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <ButtonBase
                  href="https://wa.me/542604206967"
                  focusRipple
                  sx={{
                    px: 2.6,
                    py: 1.1,
                    borderRadius: 2,
                    fontWeight: 900,
                    fontFamily: "'Red Hat Display', sans-serif",
                    bgcolor: "#FFE735",
                    color: "#5b34a5",
                    "&:hover": { bgcolor: "#ffea66" },
                    "&:focus-visible": {
                      outline: "2px solid #fff",
                      outlineOffset: 2,
                    },
                  }}
                >
                  Hablar por WhatsApp
                  <ArrowForwardIcon sx={{ ml: 1, fontSize: 20 }} />
                </ButtonBase>
              </Stack>
            </Grid>
          </Grid>
        </Box>

        {/* Links */}
        <Grid container spacing={6} justifyContent="center">
          {sections.map((sec) => (
            <Grid key={sec.title} item xs={12} sm={6} md={2.4}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: 900,
                  letterSpacing: 0.2,
                  textShadow: "0 1px 2px rgba(0,0,0,0.25)",
                  fontFamily: "'Red Hat Display', sans-serif",
                }}
              >
                {sec.title}
              </Typography>

              <Stack spacing={1}>
                {sec.links.map((l) => (
                  <Link
                    key={l.label}
                    component={RouterLink}
                    to={l.to}
                    underline="none"
                    color="inherit"
                    sx={{
                      fontSize: 14,
                      opacity: 0.95,
                      fontFamily: "'Merriweather Sans', sans-serif",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      "&:hover": { color: "#FFE735" },
                      "&:focus-visible": {
                        outline: "2px solid #FFE735",
                        outlineOffset: 2,
                      },
                    }}
                  >
                    {l.label}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        {/* Línea + legales + sociales */}
        <Divider
          sx={{
            mt: { xs: 6, md: 8 },
            mb: { xs: 3, md: 4 },
            borderColor: "rgba(236,236,236,0.6)",
          }}
        />

        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.92)",
                fontFamily: "'Merriweather Sans', sans-serif",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              © Ubika 2025 ·{" "}
              <Link
                href="https://drive.google.com/file/d/1sqeyB3MRJbD8yStOOGXMGq9PTS4EoPmJ/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="inherit"
                sx={{ "&:hover": { color: "#FFE735" } }}
              >
                Términos y Condiciones
              </Link>{" "}
              ·{" "}
              <Link
                href="https://www.webprofitdesign.com/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="inherit"
                sx={{ "&:hover": { color: "#FFE735" } }}
              >
                Preferencias
              </Link>
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack
              direction="row"
              spacing={0.5}
              justifyContent={{ xs: "center", md: "flex-end" }}
            >
              <Social
                href="https://www.instagram.com/ubikasite/"
                label="Instagram"
                Icon={InstagramIcon}
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
